import { Webhook } from '@ardoq/api-types';
import { createEntity, deleteEntity, fetchEntities } from './api';

export const webhookApi = {
  fetchAll: fetchEntities<Webhook>('webhook'),
  register: createEntity<Webhook>('webhook'),
  delete: deleteEntity('webhook'),
};
